module.exports = __webpack_public_path__ + "static/media/heidelberg.76b921cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heidelberg.jpg
// module id = 84
// module chunks = 0